var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62435 1.91675C6.11352 1.91675 4.07227 3.958 4.07227 6.46883C4.07227 8.93175 5.99852 10.9251 8.50935 11.0113C8.58602 11.0017 8.66268 11.0017 8.72018 11.0113C8.73935 11.0113 8.74893 11.0113 8.7681 11.0113C8.77768 11.0113 8.77768 11.0113 8.78727 11.0113C11.2406 10.9251 13.1668 8.93175 13.1764 6.46883C13.1764 3.958 11.1352 1.91675 8.62435 1.91675Z",
    fill: "#14141F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4939 13.5603C10.8202 11.7778 6.45974 11.7778 3.76682 13.5603C2.54974 14.3748 1.87891 15.4769 1.87891 16.6557C1.87891 17.8344 2.54974 18.9269 3.75724 19.7319C5.09891 20.6328 6.86224 21.0832 8.62557 21.0832C10.3889 21.0832 12.1522 20.6328 13.4939 19.7319C14.7014 18.9173 15.3722 17.8248 15.3722 16.6365C15.3627 15.4578 14.7014 14.3653 13.4939 13.5603Z",
    fill: "#14141F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1565 7.03434C19.3098 8.89351 17.9873 10.5227 16.1569 10.7431C16.1473 10.7431 16.1473 10.7431 16.1377 10.7431H16.109C16.0515 10.7431 15.994 10.7431 15.9461 10.7623C15.0165 10.8102 14.1636 10.5131 13.5215 9.96684C14.5086 9.08518 15.074 7.76268 14.959 6.32518C14.8919 5.54893 14.6236 4.83976 14.2211 4.23601C14.5852 4.05393 15.0069 3.93893 15.4382 3.90059C17.3165 3.73768 18.9936 5.13684 19.1565 7.03434Z",
    fill: "#14141F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0749 15.8987C20.9982 16.8283 20.404 17.6333 19.4074 18.1796C18.449 18.7066 17.2415 18.9558 16.0436 18.9271C16.7336 18.3041 17.1361 17.5279 17.2128 16.7037C17.3086 15.5154 16.7432 14.375 15.6124 13.4646C14.9703 12.9566 14.2228 12.5541 13.4082 12.2571C15.5261 11.6437 18.1903 12.0558 19.829 13.3783C20.7107 14.0875 21.1611 14.9787 21.0749 15.8987Z",
    fill: "#14141F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoProfile);
export default __webpack_public_path__ + "static/media/trvto_profile.079166b1c3caca510edfa550e73292f9.svg";
export { ForwardRef as ReactComponent };